import { omit, uniq } from 'lodash';
import { PageTargetFlags } from './page-target-flags.enum';
export const checkIsCaseInsensitive = (node) => {
    var _a, _b, _c;
    if (!((_a = node === null || node === void 0 ? void 0 : node.children) === null || _a === void 0 ? void 0 : _a[0])) {
        return false;
    }
    if ('field' in node.children[0]) {
        return Boolean((_c = (_b = node.children[0]) === null || _b === void 0 ? void 0 : _b.flags) === null || _c === void 0 ? void 0 : _c.some((flag) => flag === PageTargetFlags.IsCaseInsensitive));
    }
    else {
        return checkIsCaseInsensitive(node.children[0]);
    }
};
export const applyCaseInsensitivityToFovFilter = (filter, isCaseInsensitive) => {
    const childFlags = (filter === null || filter === void 0 ? void 0 : filter.flags) || [];
    const updatedFlags = isCaseInsensitive
        ? uniq([...childFlags, PageTargetFlags.IsCaseInsensitive])
        : childFlags.filter((flag) => flag !== PageTargetFlags.IsCaseInsensitive);
    return Object.assign(Object.assign({}, omit(filter, ['flags'])), (updatedFlags.length > 0 ? { flags: updatedFlags } : {}));
};
export const applyCaseInsensitivityToFovGroup = (target, isCaseInsensitive) => {
    return Object.assign(Object.assign({}, target), { children: target.children.map((child) => {
            if ('field' in child) {
                return applyCaseInsensitivityToFovFilter(child, isCaseInsensitive);
            }
            else {
                return applyCaseInsensitivityToFovGroup(child, isCaseInsensitive);
            }
        }) });
};
//# sourceMappingURL=case-insensitivity.js.map